/* GRADA Corporate Gift Box Builder — gift-builder.js (ES2020, no build step)

   Ported from the Laurie prototype. The shape is kept deliberately close to the
   original: one config object holds every number, one state object holds every
   answer, and derive() is a pure function from state to everything on screen.

   Phase 1 is lead-gen — the builder prices a configuration and hands it to the
   Shopify contact form. Nothing is added to cart.
*/

(function () {
  'use strict';

  var root = document.querySelector('[data-gift-builder]');
  if (!root) return;

  var configEl = root.querySelector('[data-gb-config]');
  if (!configEl) return;

  var CFG;
  try {
    CFG = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var STORAGE_KEY = 'grada_gift_builder_state';
  var KEY_STORAGE = 'grada_gift_builder_key';

  /* ============================================================
     ACCESS GATE

     When an access key is configured the page only opens at ?key=<value>.

     This hides the page from anyone who stumbles onto the URL. It is NOT
     security — the markup ships in the page source either way. It exists so a
     link can be shared for review without the page being browsable.
     ============================================================ */

  function gateAllows() {
    var required = (CFG.accessKey || '').trim();
    if (!required) return true;

    var supplied = new URLSearchParams(location.search).get('key');
    if (supplied === required) {
      // Shopify's contact form redirects to ?contact_posted=true and drops the
      // rest of the query, so remember the key for the rest of the session.
      try { sessionStorage.setItem(KEY_STORAGE, required); } catch (e) {}
      return true;
    }

    try { return sessionStorage.getItem(KEY_STORAGE) === required; } catch (e) { return false; }
  }

  if (!gateAllows()) {
    var locked = document.querySelector('[data-gb-locked]');
    if (locked) locked.hidden = false;
    // Remove rather than hide, so the configurator isn't sitting one CSS
    // toggle away in the inspector.
    root.remove();
    return;
  }

  /* ============================================================
     STATIC COPY
     ============================================================ */

  var BOTTLES = [
    {
      id: 'so',
      img: 'so',
      name: 'GRADA 01 Single Origin.',
      desc: 'The single-ingredient espresso martini. IWSC Gold, 96/100.',
      short: '01 Single Origin'
    },
    {
      id: 'decaf',
      img: 'decaf',
      name: 'GRADA 02 Midnight Decaf.',
      desc: 'The world’s first specialty decaf coffee liqueur. All the flavour, none of the caffeine. Made for after.',
      short: '02 Midnight Decaf'
    }
  ];

  // The two box tiers are the only priced things — and the only variants.
  var BOXES = [
    {
      id: 'standard',
      img: 'standard',
      name: 'The Standard box.',
      desc: 'One bottle, one Japanese hand-blown coupe, and a gift of your choosing.',
      short: 'Standard'
    },
    {
      id: 'deluxe',
      img: 'deluxe',
      name: 'The Deluxe box.',
      desc: 'One bottle, two Nick & Nora glasses, and a bigger gift. Espresso martinis for two.',
      short: 'Deluxe'
    }
  ];

  // Gifts are line item properties, not variants. Which set is offered depends
  // on the box tier; within a tier they all cost the same, so picking one
  // changes nothing about the price.
  var GIFTS = {
    socoffee: { img: 'socoffee', name: '200g Single Origin coffee, roasted in Melbourne', short: 'Single Origin coffee, 200g' },
    decafbeans: { img: 'decafbeans', name: '200g Decaf whole beans', short: 'Decaf beans, 200g' },
    cap: { img: 'cap', name: 'GRADA cap', short: 'GRADA cap' },
    tee: { img: 'tee', name: 'GRADA tee', short: 'GRADA tee' },
    shaker: { img: 'shaker', name: 'Cocktail shaker', short: 'Cocktail shaker, 550ml' },
    mega: { img: 'mega', name: 'Mega shaker, 1 litre', short: 'Mega shaker, 1L' }
  };

  var STEP_TITLES = {
    1: 'How many boxes?',
    2: 'The bottle',
    3: 'The box',
    4: 'The extra gift',
    5: 'The sleeve'
  };

  var STEP_ROW_LABELS = {
    1: 'The boxes',
    2: 'The bottle',
    3: 'The box',
    4: 'The extra gift',
    5: 'The sleeve'
  };

  /* ============================================================
     STATE
     ============================================================ */

  function freshState() {
    return {
      view: 'intro',
      open: 1,
      done: { 1: false, 2: false, 3: false, 4: false, 5: false },
      qty: CFG.moq,
      mix: 'so',
      soQty: Math.ceil(CFG.moq / 2),
      box: 'standard',
      gift: null,
      logo: null,
      drag: false,
      uploadMsg: ''
    };
  }

  var state = freshState();

  /* ============================================================
     HELPERS
     ============================================================ */

  function money(n) {
    var r = Math.round(n * 100) / 100;
    var opts = Number.isInteger(r)
      ? { maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return '$' + r.toLocaleString('en-AU', opts);
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * The theme header is fixed, so the builder has to reserve its height — the
   * sticky progress row, and the top padding of the build and done views, all
   * hang off --gb-header. Measure it rather than hardcode: the header is a
   * 32px ticker plus a 71px bar today, and a CSS guess silently clips the top
   * of the builder if either changes.
   */
  function syncHeaderOffset() {
    var header = document.querySelector('.grada-header');
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) root.style.setProperty('--gb-header', h + 'px');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function el(sel, scope) {
    return (scope || root).querySelector(sel);
  }

  /* ============================================================
     DERIVE — pure: state -> every number and label on screen
     ============================================================ */

  function derive() {
    var s = state;
    var qty = s.qty;
    var moq = CFG.moq;

    // Split mix. soQty is only meaningful when mix === 'both'.
    var soQ = s.mix === 'both'
      ? Math.min(Math.max(1, s.soQty), Math.max(1, qty - 1))
      : (s.mix === 'so' ? qty : 0);
    var dcQ = qty - soQ;

    // Both bottles cost the same, and the gift is included in the tier price.
    // So a box costs the tier price plus the optional logo, full stop — the
    // single-price-per-tier model is what collapses the catalogue to two SKUs.
    var boxEx = CFG.boxes[s.box].ex + (s.logo ? CFG.sleeveLogoEx : 0);

    // Kept as two figures so a future split-pricing decision doesn't require
    // unpicking the maths; today they are identical.
    var soStd = boxEx;
    var dcStd = boxEx;

    // Volume tier — highest tier whose minimum we have reached.
    var tierIdx = -1;
    CFG.volumeTiers.forEach(function (t, i) { if (qty >= t.min) tierIdx = i; });
    var pct = tierIdx >= 0 ? CFG.volumeTiers[tierIdx].pct : 0;
    var disc = 1 - pct / 100;

    var soUnit = soStd * disc;
    var dcUnit = dcStd * disc;
    var stdTotalEx = soQ * soStd + dcQ * dcStd;
    var totalEx = soQ * soUnit + dcQ * dcUnit;
    var savedEx = stdTotalEx - totalEx;

    var nextT = null;
    for (var i = 0; i < CFG.volumeTiers.length; i++) {
      if (CFG.volumeTiers[i].min > qty && CFG.volumeTiers[i].pct > pct) { nextT = CFG.volumeTiers[i]; break; }
    }

    // Retail value line. Sums only the RRPs we actually know.
    var rrpSum = CFG.rrp.bottle;
    var boxRrp = CFG.rrp.box[s.box];
    var rrpTbc = boxRrp == null;
    if (boxRrp != null) rrpSum += boxRrp;

    var giftCur = s.gift && s.gift !== 'none' ? GIFTS[s.gift] : null;
    var bottleShort = s.mix === 'both'
      ? soQ + ' SO · ' + dcQ + ' Decaf'
      : BOTTLES.filter(function (b) { return b.id === s.mix; })[0].short;
    var boxShort = BOXES.filter(function (b) { return b.id === s.box; })[0].short;
    var giftShort = s.gift === 'none' ? 'No extra gift' : (giftCur ? giftCur.short : '');
    var sleeveShort = s.logo ? 'Your logo, + ' + money(CFG.sleeveLogoEx) + ' a box' : 'GRADA sleeve';

    var doneCount = [1, 2, 3, 4, 5].filter(function (n) { return s.done[n]; }).length;
    var allPacked = doneCount === 5;

    var curUnit = s.mix === 'so' ? soUnit : dcUnit;
    var curStd = s.mix === 'so' ? soStd : dcStd;

    var perBoxExLine = s.mix === 'both'
      ? 'SO ' + money(soUnit) + ' · Decaf ' + money(dcUnit)
      : money(curUnit) + ' a box';
    var perBoxIncLine = s.mix === 'both'
      ? 'SO ' + money(soUnit * 1.1) + ' · Decaf ' + money(dcUnit * 1.1)
      : money(curUnit * 1.1) + ' a box';

    var avgStd = stdTotalEx / Math.max(1, qty);
    var nudgeUnitBase = s.mix === 'both' ? Math.min(soStd, dcStd) : curStd;
    var nudgeLine = nextT
      ? 'Order ' + (nextT.min - qty) + ' more boxes to reach ' + nextT.pct + '% off. ' +
        'Your price drops to ' + (s.mix === 'both' ? 'from ' : '') +
        money(nudgeUnitBase * (1 - nextT.pct / 100)) + ' a box and you save ' +
        money(nextT.min * avgStd * nextT.pct / 100) + ' across the order.'
      : '';

    return {
      qty: qty, moq: moq, soQ: soQ, dcQ: dcQ,
      pct: pct, tierIdx: tierIdx, nextT: nextT,
      soStd: soStd, dcStd: dcStd, soUnit: soUnit, dcUnit: dcUnit,
      curUnit: curUnit, curStd: curStd,
      totalEx: totalEx, savedEx: savedEx,
      hasSaved: pct > 0 && qty >= moq,
      hasNudge: !!nextT && qty >= moq,
      nudgeLine: nudgeLine,
      barNudge: nextT ? '+' + (nextT.min - qty) + ' boxes unlocks ' + nextT.pct + '% off' : '',
      underMoq: qty < moq,
      rrpDisp: money(rrpSum) + (rrpTbc ? '+' : ''),
      bottleShort: bottleShort, boxShort: boxShort,
      giftShort: giftShort, sleeveShort: sleeveShort,
      giftCur: giftCur,
      doneCount: doneCount, allPacked: allPacked,
      perBoxExLine: perBoxExLine, perBoxIncLine: perBoxIncLine
    };
  }

  /* ============================================================
     STATE TRANSITIONS
     ============================================================ */

  function firstUndone() {
    for (var i = 1; i <= 5; i++) { if (!state.done[i]) return i; }
    return 6;
  }

  function answer(n, patch) {
    Object.assign(state, patch || {});
    state.done[n] = true;
    state.open = firstUndone();
    render();
    setTimeout(function () { scrollToStep(state.open); }, 80);
  }

  function openStep(n) {
    state.open = n;
    render();
    setTimeout(function () { scrollToStep(n); }, 80);
  }

  function scrollToStep(n) {
    var target = el('[data-gb-step="' + n + '"]') || el('[data-gb-quote]');
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: top, behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  function setView(v) {
    state.view = v;
    try {
      if (v === 'intro') history.pushState(null, '', location.pathname + location.search);
      else location.hash = v;
    } catch (e) {}
    render();
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  function setSplit(n) {
    state.soQty = Math.min(Math.max(1, n), Math.max(1, state.qty - 1));
    render();
  }

  /* ============================================================
     RENDER — steps
     ============================================================ */

  function summaryRowHtml(n, value, thumb) {
    return '' +
      '<button class="gb-row" type="button" data-gb-openstep="' + n + '">' +
        '<span class="gb-row__num">' + n + '</span>' +
        '<span class="gb-row__text"><b>' + esc(STEP_ROW_LABELS[n]) + '</b> <span class="gb-row__value">· ' + esc(value) + '</span></span>' +
        (thumb ? '<span class="gb-row__thumb" style="background-image:url(' + esc(thumb) + ')"></span>' : '') +
        '<span class="gb-row__edit">Edit</span>' +
      '</button>';
  }

  function cardHtml(n, body) {
    // enteringStep is set by renderBuild when the open step has just changed.
    var enter = enteringStep === n ? ' gb-card--enter' : '';
    return '' +
      '<div class="gb-card' + enter + '" data-gb-open>' +
        '<p class="gb-card__eyebrow">Step ' + n + ' of 5</p>' +
        '<h2 class="gb-card__title">' + esc(STEP_TITLES[n]) + '</h2>' +
        body +
      '</div>';
  }

  function optionCardHtml(opts) {
    // opts: { id, group, selected, img, name, desc, tag, variant }
    return '' +
      '<button class="gb-opt' + (opts.selected ? ' is-selected' : '') + (opts.variant ? ' gb-opt--' + opts.variant : '') + '"' +
        ' type="button" role="radio" aria-checked="' + (opts.selected ? 'true' : 'false') + '"' +
        ' data-gb-pick="' + opts.group + '" data-gb-value="' + esc(opts.id) + '">' +
        (opts.img
          ? '<span class="gb-opt__photo" style="background-image:url(' + esc(opts.img) + ')">' +
              '<span class="gb-opt__badge" aria-hidden="true"></span>' +
            '</span>'
          : '<span class="gb-opt__photo gb-opt__photo--empty"><span class="gb-opt__badge" aria-hidden="true"></span></span>') +
        '<span class="gb-opt__body">' +
          '<span class="gb-opt__text">' +
            '<span class="gb-opt__name">' + esc(opts.name) + '</span>' +
            (opts.desc ? '<span class="gb-opt__desc">' + esc(opts.desc) + '</span>' : '') +
          '</span>' +
          '<span class="gb-opt__tag">' + esc(opts.tag) + '</span>' +
        '</span>' +
      '</button>';
  }

  function renderStep1(d) {
    var chips = CFG.volumeTiers.map(function (t) { return t.min; })
      .map(function (v) {
        return '<button class="gb-chip' + (d.qty === v ? ' is-on' : '') + '" type="button" data-gb-qtychip="' + v + '">' + v + '</button>';
      }).join('');

    var tierCells = tierCellsHtml(d);

    var body = '' +
      '<p class="gb-card__lede">Minimum ' + d.moq + ' for corporate orders.</p>' +
      '<div class="gb-chips">' + chips + '</div>' +
      '<div class="gb-stepper">' +
        '<span class="gb-stepper__label">Number of boxes</span>' +
        '<button class="gb-stepper__btn" type="button" data-gb-qty="dec" aria-label="Fewer boxes">&minus;</button>' +
        '<input class="gb-stepper__input" type="text" inputmode="numeric" value="' + d.qty + '" data-gb-qtyinput aria-label="Number of boxes">' +
        '<button class="gb-stepper__btn" type="button" data-gb-qty="inc" aria-label="More boxes">+</button>' +
      '</div>' +
      '<div class="gb-tiers" aria-label="Volume pricing tiers" data-gb-tiers>' + tierCells + '</div>' +
      // Always present, even when empty, so quantity changes can patch it
      // instead of rebuilding the card and stealing focus from the input.
      '<div data-gb-notes>' + step1NotesHtml(d) + '</div>' +
      '<button class="grada-button grada-button--blue grada-button--full gb-card__confirm" type="button" data-gb-confirm="1"' +
        (d.underMoq ? ' disabled' : '') + '>Lock in ' + d.qty + ' boxes</button>';

    return cardHtml(1, body);
  }

  function step1NotesHtml(d) {
    return '' +
      (d.hasNudge ? '<p class="gb-note">' + esc(d.nudgeLine) + '</p>' : '') +
      (d.hasSaved ? '<p class="gb-note"><b>' + d.pct + '% off unlocked.</b> You save ' + esc(money(d.savedEx)) + ' across the order.</p>' : '') +
      (d.underMoq
        ? '<div class="gb-alert" role="status">' +
            '<b>Corporate orders start at ' + d.moq + ' boxes.</b> ' +
            'Under ' + d.moq + '? Grab our <a href="' + esc(CFG.retailUrl) + '">retail gift box</a> instead.' +
          '</div>'
        : '');
  }

  function tierCellsHtml(d) {
    return CFG.volumeTiers.map(function (t, i) {
      var cur = i === d.tierIdx;
      var next = !!d.nextT && t.min === d.nextT.min;
      var cls = 'gb-tier' + (cur ? ' is-current' : '') + (next ? ' is-next' : '');
      return '<div class="' + cls + '">' +
        '<span class="gb-tier__qty">' + t.min + '+</span>' +
        '<span class="gb-tier__sub">' + (t.pct > 0 ? t.pct + '% off' : 'Corporate') + '</span>' +
      '</div>';
    }).join('');
  }

  function renderStep2(d) {
    var s = state;
    var opts = BOTTLES.map(function (b) {
      return optionCardHtml({
        id: b.id, group: 'mix', selected: s.mix === b.id, img: CFG.img[b.img],
        name: b.name, desc: b.desc,
        tag: 'Either, same price'
      });
    }).join('');

    var both = '' +
      '<button class="gb-opt gb-opt--plain' + (s.mix === 'both' ? ' is-selected' : '') + '"' +
        ' type="button" role="radio" aria-checked="' + (s.mix === 'both' ? 'true' : 'false') + '" data-gb-pick="mix" data-gb-value="both">' +
        '<span class="gb-opt__body">' +
          '<span class="gb-opt__text">' +
            '<span class="gb-opt__name">Some of each.</span>' +
            '<span class="gb-opt__desc">Split the order between the two bottles. Say ' +
              '<span data-gb-halfhint>' + Math.ceil(d.qty / 2) + ' and ' + Math.floor(d.qty / 2) + '</span> of each.</span>' +
          '</span>' +
          '<span class="gb-opt__tag">No extra cost</span>' +
        '</span>' +
      '</button>';

    var split = '';
    if (s.mix === 'both') {
      split = '' +
        '<div class="gb-split">' +
          '<div class="gb-split__row">' +
            '<span class="gb-split__name">Single Origin</span>' +
            '<button class="gb-stepper__btn" type="button" data-gb-split="so-dec" aria-label="Fewer Single Origin">&minus;</button>' +
            '<span class="gb-split__qty" data-gb-soqty>' + d.soQ + '</span>' +
            '<button class="gb-stepper__btn" type="button" data-gb-split="so-inc" aria-label="More Single Origin">+</button>' +
          '</div>' +
          '<div class="gb-split__row">' +
            '<span class="gb-split__name">Midnight Decaf</span>' +
            '<button class="gb-stepper__btn" type="button" data-gb-split="dc-dec" aria-label="Fewer Midnight Decaf">&minus;</button>' +
            '<span class="gb-split__qty" data-gb-dcqty>' + d.dcQ + '</span>' +
            '<button class="gb-stepper__btn" type="button" data-gb-split="dc-inc" aria-label="More Midnight Decaf">+</button>' +
          '</div>' +
          '<p class="gb-split__hint" data-gb-splithint>Always adds up to your ' + d.qty + ' boxes.</p>' +
          '<button class="grada-button grada-button--blue grada-button--full" type="button" data-gb-confirm="2">Lock in the split</button>' +
        '</div>';
    }

    var body = '' +
      '<p class="gb-card__lede">One in every box. Pick one for the whole order, or split it.</p>' +
      '<div class="gb-opts" role="radiogroup" aria-label="Bottle">' + opts + both + '</div>' +
      split;

    return cardHtml(2, body);
  }

  function renderStep3(d) {
    var s = state;
    var opts = BOXES.map(function (b) {
      return optionCardHtml({
        id: b.id, group: 'box', selected: s.box === b.id, img: CFG.img[b.img],
        name: b.name, desc: b.desc,
        tag: money(CFG.boxes[b.id].ex) + ' a box'
      });
    }).join('');

    return cardHtml(3,
      '<p class="gb-card__lede">Two ways to send it. Everything in the box is included in the price.</p>' +
      '<div class="gb-opts" role="radiogroup" aria-label="Box">' + opts + '</div>');
  }

  function renderStep4() {
    var s = state;
    var opts = CFG.boxes[s.box].gifts.map(function (id) {
      var g = GIFTS[id];
      return optionCardHtml({
        id: id, group: 'gift', selected: s.gift === id, img: CFG.img[g.img],
        // No price tag — every gift in a tier costs the same, which is the
        // whole reason gifts don't multiply the catalogue.
        name: g.name, tag: 'Included', variant: 'grid'
      });
    });

    if (CFG.allowGiftSkip) {
      opts.push(optionCardHtml({
        id: 'none', group: 'gift', selected: s.gift === 'none', img: null,
        name: 'Keep it to the bottle and glassware', tag: 'Included', variant: 'grid'
      }));
    }

    return cardHtml(4,
      '<p class="gb-card__lede">One more thing in every box. Pick what suits your people.</p>' +
      '<div class="gb-opts gb-opts--grid" role="radiogroup" aria-label="Extra gift">' + opts.join('') + '</div>');
  }

  function renderStep5() {
    var s = state;
    var sleeveInner;
    if (s.logo && s.logo.kind === 'img') {
      sleeveInner = '<span class="gb-sleeve__logo" role="img" aria-label="Your logo on the sleeve" style="background-image:url(' + esc(s.logo.url) + ')"></span>';
    } else if (s.logo && s.logo.kind === 'pdf') {
      sleeveInner = '<span class="gb-sleeve__pdf">' + esc(s.logo.name) + ' · proof to follow</span>';
    } else {
      sleeveInner = '<img class="gb-sleeve__mark" src="' + esc(CFG.img.sleeve) + '" alt="GRADA sleeve">';
    }

    var body = '' +
      '<p class="gb-card__lede">Drop your logo here and see it on the sleeve. We send you a proof before anything prints.</p>' +
      '<p class="gb-card__note">Your logo adds <b>' + esc(money(CFG.sleeveLogoEx)) + ' a box</b>. The GRADA sleeve costs nothing.</p>' +
      '<button class="gb-drop' + (s.drag ? ' is-dragging' : '') + '" type="button" data-gb-dropzone>' +
        '<span>Drag your logo in, or tap to upload. PNG, SVG or PDF.</span>' +
        (s.uploadMsg ? '<span class="gb-drop__msg">' + esc(s.uploadMsg) + '</span>' : '') +
      '</button>' +
      '<input type="file" accept=".png,.svg,.pdf,image/png,image/svg+xml,application/pdf" data-gb-file hidden aria-label="Upload your logo">' +
      '<div class="gb-sleeve"><div class="gb-sleeve__band">' + sleeveInner + '</div></div>' +
      (s.logo
        ? '<div class="gb-logofile">' +
            '<span class="gb-logofile__name">' + esc(s.logo.name) + '</span>' +
            '<span class="gb-logofile__price">+ ' + esc(money(CFG.sleeveLogoEx)) + ' a box</span>' +
            '<button class="gb-logofile__remove" type="button" data-gb-removelogo>Remove</button>' +
          '</div>' +
          '<button class="grada-button grada-button--blue grada-button--full gb-card__confirm" type="button" data-gb-confirm="5">Print my logo</button>'
        : '<button class="grada-button grada-button--ghost grada-button--full gb-card__confirm" type="button" data-gb-confirm="5">Keep the GRADA sleeve</button>') +
      '<p class="gb-card__fineprint">Nothing prints until you approve the proof.</p>';

    return cardHtml(5, body);
  }

  var STEP_RENDERERS = {
    1: renderStep1, 2: renderStep2, 3: renderStep3, 4: renderStep4, 5: renderStep5
  };

  function stepValue(n, d) {
    if (n === 1) return d.qty + ' boxes' + (d.pct > 0 ? ' · ' + d.pct + '% off' : '');
    if (n === 2) return d.bottleShort;
    if (n === 3) return d.boxShort;
    if (n === 4) return d.giftShort;
    return d.sleeveShort;
  }

  function stepThumb(n, d) {
    if (n === 2) return CFG.img[state.mix === 'decaf' ? 'decaf' : 'so'];
    if (n === 3) return CFG.img[state.box];
    if (n === 4) return d.giftCur ? CFG.img[d.giftCur.img] : null;
    return null;
  }

  /* ============================================================
     RENDER — top level
     ============================================================ */

  // Structural identity of the step list. Anything that adds, removes or
  // reorders a node belongs here; anything that only changes a number does not
  // (those are patched, so typing in the quantity field keeps focus).
  var lastStructureKey = null;
  var lastOpenStep = null;
  var enteringStep = null;

  function structureKey() {
    return [
      state.view,
      state.open,
      [1, 2, 3, 4, 5].map(function (n) { return state.done[n] ? 1 : 0; }).join(''),
      state.mix,
      state.box,
      state.gift,
      state.logo ? state.logo.kind : '-',
      state.uploadMsg ? 'msg' : '-'
      // state.drag is deliberately absent — rebuilding the card mid-drag
      // destroys the element the drag is over. It is patched as a class.
    ].join('|');
  }

  function patchOpenStep(d) {
    if (state.open === 1) {
      [].forEach.call(root.querySelectorAll('[data-gb-qtychip]'), function (chip) {
        chip.classList.toggle('is-on', parseInt(chip.getAttribute('data-gb-qtychip'), 10) === d.qty);
      });

      var input = el('[data-gb-qtyinput]');
      // Never write back into the field the user is typing in.
      if (input && document.activeElement !== input && input.value !== String(d.qty)) {
        input.value = String(d.qty);
      }

      var tiers = el('[data-gb-tiers]');
      if (tiers) tiers.innerHTML = tierCellsHtml(d);

      var notes = el('[data-gb-notes]');
      if (notes) notes.innerHTML = step1NotesHtml(d);

      var confirm = el('[data-gb-confirm="1"]');
      if (confirm) {
        confirm.disabled = d.underMoq;
        confirm.textContent = 'Lock in ' + d.qty + ' boxes';
      }
      return;
    }

    if (state.open === 2) {
      var half = el('[data-gb-halfhint]');
      if (half) half.textContent = Math.ceil(d.qty / 2) + ' and ' + Math.floor(d.qty / 2);

      var soq = el('[data-gb-soqty]');
      if (soq) soq.textContent = String(d.soQ);

      var dcq = el('[data-gb-dcqty]');
      if (dcq) dcq.textContent = String(d.dcQ);

      var hint = el('[data-gb-splithint]');
      if (hint) hint.textContent = 'Always adds up to your ' + d.qty + ' boxes.';
      return;
    }

    if (state.open === 5) {
      var zone = el('[data-gb-dropzone]');
      if (zone) zone.classList.toggle('is-dragging', !!state.drag);
    }
  }

  function render() {
    var d = derive();

    // Views
    ['intro', 'build', 'done'].forEach(function (v) {
      var node = el('[data-gb-view="' + v + '"]');
      if (node) node.hidden = state.view !== v;
    });

    if (state.view === 'build') renderBuild(d);
    if (state.view === 'done') renderDone(d);
  }

  function renderBuild(d) {
    // Progress
    var packed = el('[data-gb-packed]');
    if (packed) packed.textContent = 'Packed ' + d.doneCount + '/5';

    var segs = el('[data-gb-segments]');
    if (segs) {
      [].forEach.call(segs.children, function (node, i) {
        node.classList.toggle('is-done', !!state.done[i + 1]);
      });
      if (!segs.children.length) {
        segs.innerHTML = [1, 2, 3, 4, 5].map(function (n) {
          return '<span class="gb-progress__seg' + (state.done[n] ? ' is-done' : '') + '"></span>';
        }).join('');
      }
    }

    // Rebuilding the steps replaces every node, which restarts the entry
    // animation and drops focus. Only do it when the layout genuinely changes;
    // otherwise patch the numbers in place.
    var key = structureKey();
    var stepsHost = el('[data-gb-steps]');
    if (!stepsHost) return;

    if (key !== lastStructureKey) {
      enteringStep = state.open !== lastOpenStep ? state.open : null;

      var html = '';
      for (var n = 1; n <= 5; n++) {
        var isOpen = state.open === n;
        html += '<div data-gb-step="' + n + '">';
        if (state.done[n] && !isOpen) html += summaryRowHtml(n, stepValue(n, d), stepThumb(n, d));
        if (isOpen) html += STEP_RENDERERS[n](d);
        html += '</div>';
      }
      stepsHost.innerHTML = html;

      enteringStep = null;
      lastStructureKey = key;
      lastOpenStep = state.open;
    } else {
      patchOpenStep(d);
    }

    // Last step — quote form or cart card, depending on the section setting.
    var cartMode = CFG.checkoutMode === 'cart';
    var laurieMode = CFG.checkoutMode === 'laurie';
    var valueHtml = '<b>' + esc(d.rrpDisp) + '</b> of GRADA at retail in every box. ' +
      'Your price: <b>' + esc(d.perBoxIncLine) + '</b> inc GST.';

    var quote = el('[data-gb-quote]');
    if (quote) {
      quote.hidden = cartMode || !d.allPacked;
      var submitBtn = el('[data-gb-submit]');
      if (submitBtn) submitBtn.textContent = laurieMode ? 'Place my order' : 'Get my quote';
      var valueLine = el('[data-gb-valueline]');
      if (valueLine) valueLine.innerHTML = valueHtml;
    }

    var cartCard = el('[data-gb-cartcard]');
    if (cartCard) {
      cartCard.hidden = !cartMode || !d.allPacked;
      var cartValue = el('[data-gb-valueline-cart]');
      if (cartValue) cartValue.innerHTML = valueHtml;
      if (cartMode && d.allPacked) renderCartLines(d);
    }

    renderBar(d);
  }

  // A preview of exactly what will land in the cart. Worth showing because the
  // split case produces two lines and the logo produces a third, which is
  // otherwise a surprise at checkout.
  function renderCartLines(d) {
    var host = el('[data-gb-cartlines]');
    if (!host) return;

    var items = buildCartItems(d);
    if (!items) {
      host.innerHTML = '<p class="gb-cartlines__warn">No variant ID set for the ' +
        esc(d.boxShort) + ' box yet, so this can’t be added to a cart. ' +
        'Set it in the theme editor under Checkout.</p>';
      return;
    }

    host.innerHTML = items.map(function (it) {
      var isLogo = String(it.id) === String(CFG.logoVariantId);
      var title = isLogo ? 'Sleeve logo printing' : d.boxShort + ' box — ' + it.properties['Bottle'];
      var sub = isLogo
        ? it.properties['Artwork']
        : it.properties['Extra gift'] + ' · ' + it.properties['Sleeve'];
      return '<div class="gb-cartline">' +
          '<span class="gb-cartline__qty">' + it.quantity + '&times;</span>' +
          '<span class="gb-cartline__body">' +
            '<span class="gb-cartline__title">' + esc(title) + '</span>' +
            '<span class="gb-cartline__sub">' + esc(sub) + '</span>' +
          '</span>' +
        '</div>';
    }).join('');
  }

  function renderBar(d) {
    var bar = el('[data-gb-bar]');
    if (!bar) return;
    bar.hidden = false;

    var figures = el('[data-gb-barfigures]');
    var showStrike = d.pct > 0 && state.mix !== 'both';
    // The prototype dropped the box count on a split order; always show it.
    var qtyTxt = d.qty + ' boxes · ';
    var unitTxt = state.mix === 'both'
      ? d.soQ + ' SO at ' + money(d.soUnit) + ' · ' + d.dcQ + ' Decaf at ' + money(d.dcUnit)
      : money(d.curUnit) + ' a box';

    if (figures) {
      figures.innerHTML = '' +
        '<span class="gb-bar__total">' + esc(money(d.totalEx)) + '</span>' +
        '<span class="gb-bar__unit"> total · ex GST</span>' +
        (d.hasSaved ? '<span class="gb-bar__saved"> · you save ' + esc(money(d.savedEx)) + '</span>' : '') +
        '<br><span class="gb-bar__line">' + esc(qtyTxt) +
          (showStrike ? '<s>' + esc(money(d.curStd)) + '</s> ' : '') + esc(unitTxt) +
        '</span>' +
        (d.hasNudge ? '<br><span class="gb-bar__nudge">' + esc(d.barNudge) + '</span>' : '');
    }

    // The bar's CTA advances the open step, or submits once everything is packed.
    var cta = el('[data-gb-advance]');
    if (!cta) return;

    var giftBlocked = state.open === 4 && !state.gift && !CFG.allowGiftSkip && !d.allPacked;
    var qtyBlocked = state.open === 1 && d.underMoq && !d.allPacked;

    if (d.allPacked) {
      // Reopening step 1 and dropping below the minimum has to re-block the
      // quote, otherwise a packed order can be submitted under the MOQ.
      cta.textContent = CFG.checkoutMode === 'cart' ? 'Add to cart'
        : CFG.checkoutMode === 'laurie' ? 'Place my order'
        : 'Get my quote';
      cta.disabled = d.underMoq;
    } else {
      cta.textContent = giftBlocked ? 'Pick a gift' : 'Next';
      cta.disabled = giftBlocked || qtyBlocked;
    }

    var hint = el('[data-gb-submithint]');
    if (hint) {
      hint.hidden = !(d.allPacked && d.underMoq);
      hint.textContent = 'Orders start at ' + d.moq + ' boxes.';
    }
  }

  function renderDone(d) {
    var saved = el('[data-gb-savedline]');
    var summary = el('[data-gb-summary]');

    // After a contact-form POST the page has reloaded, so read back what we
    // stashed at submit time rather than the (now reset) live state.
    var snap = readSnapshot();
    if (!snap) {
      if (summary) summary.hidden = true;
      if (saved) saved.textContent = '';
      return;
    }

    if (saved) {
      saved.textContent = snap.pct > 0
        ? 'Your ' + snap.pct + '% volume saving is locked into this price. '
        : '';
    }

    // Laurie mode raises a real order, so the confirmation says so rather than
    // promising a quote that is already sitting in their inbox.
    var title = el('[data-gb-donetitle]');
    var lede = el('[data-gb-donelede]');
    var orderName = el('[data-gb-ordername]');
    var invoice = el('[data-gb-invoice]');

    if (snap.invoiceUrl) {
      if (title) title.textContent = 'Done. Your order is raised.';
      if (lede) {
        lede.innerHTML = 'We have emailed your invoice. ' +
          '<span data-gb-savedline>' + esc(saved ? saved.textContent : '') + '</span>' +
          'Nothing prints until you approve the proof of your sleeve.';
      }
      if (orderName && snap.orderName) {
        orderName.hidden = false;
        orderName.textContent = 'Order ' + snap.orderName;
      }
      if (invoice) {
        invoice.hidden = false;
        invoice.href = snap.invoiceUrl;
      }
    } else {
      if (orderName) orderName.hidden = true;
      if (invoice) invoice.hidden = true;
    }

    if (summary) {
      summary.hidden = false;
      var rows = [
        ['Boxes', String(snap.qty)],
        ['Bottle', snap.bottle],
        ['Box', snap.box],
        ['Extra gift', snap.gift],
        ['Sleeve', snap.sleeve]
      ];
      if (snap.pct > 0) rows.push(['Volume saving', snap.pct + '% · −' + snap.saved]);
      rows.push(['Per box, ex GST', snap.perBox]);
      rows.push(['Order total, ex GST', snap.total]);

      summary.innerHTML = rows.map(function (r) {
        return '<div class="gb-sumrow"><span>' + esc(r[0]) + '</span><b>' + esc(r[1]) + '</b></div>';
      }).join('') + '<p class="gb-sumfoot">' + esc(snap.totalInc) + ' total inc GST</p>';
    }
  }

  /* ============================================================
     SNAPSHOT — survives the contact form's page reload
     ============================================================ */

  function buildSnapshot(d) {
    return {
      qty: d.qty,
      bottle: state.mix === 'both'
        ? d.soQ + ' × Single Origin, ' + d.dcQ + ' × Midnight Decaf'
        : d.bottleShort,
      box: d.boxShort,
      gift: d.giftShort,
      sleeve: d.sleeveShort,
      logoName: state.logo ? state.logo.name : '',
      pct: d.pct,
      saved: money(d.savedEx),
      perBox: d.perBoxExLine.replace(' a box', ''),
      total: money(d.totalEx),
      totalInc: money(d.totalEx * 1.1)
    };
  }

  function writeSnapshot(snap) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snap)); } catch (e) {}
  }

  function readSnapshot() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function clearSnapshot() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  /* ============================================================
     CART MAPPING

     Builder state -> Shopify line items.

     The box tier is the only variant. Bottle, gift and sleeve ride along as
     line item properties, so a split order is simply two lines of the same
     variant carrying different properties.

     Note what is NOT here: price. Shopify prices from the variant, so the
     figures the builder shows are display only. Volume discounts have to be
     applied by a discount Function at checkout — the cart cannot be told what
     something costs.
     ============================================================ */

  function buildCartItems(d) {
    var variantId = CFG.boxes[state.box].variantId;
    if (!variantId) return null;

    var giftLabel = d.giftCur ? d.giftCur.short : (state.gift === 'none' ? 'No extra gift' : '');
    var sleeveLabel = state.logo ? 'Customer logo — ' + state.logo.name : 'GRADA sleeve';

    function line(bottleShort, quantity) {
      return {
        id: String(variantId),
        quantity: quantity,
        properties: {
          'Bottle': bottleShort,
          'Extra gift': giftLabel,
          'Sleeve': sleeveLabel,
          'Box': d.boxShort
        }
      };
    }

    var items = [];
    if (state.mix === 'both') {
      // Two lines, same variant, different properties — Shopify keeps them
      // separate precisely because the properties differ.
      if (d.soQ > 0) items.push(line('01 Single Origin', d.soQ));
      if (d.dcQ > 0) items.push(line('02 Midnight Decaf', d.dcQ));
    } else {
      items.push(line(d.bottleShort, d.qty));
    }

    // Logo printing is its own product so the upcharge stays visible on the
    // invoice rather than hiding inside a variant price.
    if (state.logo && CFG.logoVariantId) {
      items.push({
        id: String(CFG.logoVariantId),
        quantity: d.qty,
        properties: { 'Artwork': state.logo.name, 'Proof': 'Required before printing' }
      });
    }

    return items;
  }

  /* ============================================================
     LAURIE ORDERING

     Posts the *configuration* to Laurie, which prices it, raises a Shopify
     draft order and emails an invoice. Deliberately sends no prices: Laurie
     recomputes them, so nothing here can decide what a customer is charged.

     This is the only mode where volume discounts survive to checkout — the
     Shopify cart prices from the variant and cannot apply them on this plan.
     ============================================================ */

  function laurieContact() {
    var form = el('#gift-builder-form');
    if (!form) return null;
    var val = function (name) {
      var input = form.querySelector('[name="contact[' + name + ']"]');
      return input ? input.value.trim() : '';
    };
    return {
      name: val('Name'),
      company: val('Company'),
      email: val('email'),
      phone: val('Phone'),
      suburb: val('Delivery suburb'),
      neededBy: val('Needed by'),
      notes: val('Notes')
    };
  }

  function submitToLaurie(d, button) {
    if (!d.allPacked || d.underMoq) {
      openStep(d.underMoq ? 1 : firstUndone());
      return;
    }

    var form = el('#gift-builder-form');
    var hint = el('[data-gb-submithint]');

    // Let the browser do the required-field work rather than reimplementing it.
    if (form && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var endpoint = (CFG.laurieEndpoint || '').trim();
    if (!endpoint) {
      if (hint) { hint.hidden = false; hint.textContent = 'Ordering is not configured yet.'; }
      return;
    }

    var contact = laurieContact();
    if (hint) hint.hidden = true;
    if (button) { button.disabled = true; button.textContent = 'Sending…'; }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        config: {
          qty: d.qty,
          mix: state.mix,
          soQty: state.mix === 'both' ? d.soQ : undefined,
          box: state.box,
          gift: state.gift,
          logo: state.logo ? state.logo.name : null
        },
        contact: contact
      })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.error || 'Could not place the order.');
          return body;
        });
      })
      .then(function (body) {
        writeSnapshot(Object.assign(buildSnapshot(d), {
          orderName: body.orderName,
          invoiceUrl: body.invoiceUrl
        }));
        setView('done');
      })
      .catch(function (e) {
        if (hint) { hint.hidden = false; hint.textContent = e.message || 'Could not place the order.'; }
        if (button) { button.disabled = false; button.textContent = 'Place my order'; }
      });
  }

  function addToCart(d) {
    var items = buildCartItems(d);
    if (!items) return Promise.reject(new Error('No variant ID configured for the ' + d.boxShort + ' box.'));

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
        return body;
      });
    });
  }

  /* ============================================================
     LOGO UPLOAD

     Phase 1 note: the file itself is never transmitted. Shopify's contact form
     has no file field, so we preview it locally and tell the team the filename
     so they can chase the artwork with the proof.
     ============================================================ */

  function handleFile(f) {
    if (!f) return;
    var type = (f.type || '').toLowerCase();
    var name = f.name;

    if (type === 'application/pdf' || /\.pdf$/i.test(name)) {
      state.logo = { kind: 'pdf', name: name };
      state.uploadMsg = '';
      state.drag = false;
      render();
      return;
    }

    if (type === 'image/png' || type === 'image/svg+xml' || /\.(png|svg)$/i.test(name)) {
      var reader = new FileReader();
      reader.onload = function () {
        state.logo = { kind: 'img', name: name, url: reader.result };
        state.uploadMsg = '';
        state.drag = false;
        render();
      };
      reader.readAsDataURL(f);
      return;
    }

    state.uploadMsg = 'PNG, SVG or PDF only.';
    state.drag = false;
    render();
  }

  /* ============================================================
     EVENTS
     ============================================================ */

  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-gb-start], [data-gb-back], [data-gb-restart], [data-gb-openstep],' +
      '[data-gb-qtychip], [data-gb-qty], [data-gb-confirm], [data-gb-pick], [data-gb-split],' +
      '[data-gb-dropzone], [data-gb-removelogo], [data-gb-advance], [data-gb-addtocart]');
    if (!t || !root.contains(t)) return;

    var d = derive();

    if (t.hasAttribute('data-gb-start')) {
      state.open = firstUndone();
      setView('build');
      return;
    }

    if (t.hasAttribute('data-gb-back')) { setView('intro'); return; }

    if (t.hasAttribute('data-gb-restart')) {
      state = freshState();
      clearSnapshot();
      setView('intro');
      return;
    }

    if (t.hasAttribute('data-gb-openstep')) {
      openStep(parseInt(t.getAttribute('data-gb-openstep'), 10));
      return;
    }

    if (t.hasAttribute('data-gb-qtychip')) {
      var v = parseInt(t.getAttribute('data-gb-qtychip'), 10);
      state.qty = v;
      state.soQty = Math.ceil(v / 2);
      render();
      return;
    }

    if (t.hasAttribute('data-gb-qty')) {
      var dir = t.getAttribute('data-gb-qty');
      state.qty = dir === 'inc' ? state.qty + 1 : Math.max(1, state.qty - 1);
      render();
      return;
    }

    if (t.hasAttribute('data-gb-confirm')) {
      var step = parseInt(t.getAttribute('data-gb-confirm'), 10);
      if (step === 1 && d.underMoq) return;
      if (step === 1) answer(1, { soQty: Math.min(Math.max(1, state.soQty), Math.max(1, state.qty - 1)) });
      else answer(step, {});
      return;
    }

    if (t.hasAttribute('data-gb-pick')) {
      var group = t.getAttribute('data-gb-pick');
      var value = t.getAttribute('data-gb-value');

      if (group === 'mix') {
        // "Some of each" opens the split editor rather than completing the step.
        if (value === 'both') { state.mix = 'both'; render(); return; }
        answer(2, { mix: value });
        return;
      }
      if (group === 'box') {
        // Each tier offers a different gift set. If the chosen gift isn't in
        // the new tier's set, clear it and re-open step 4 rather than carrying
        // a selection the customer can no longer see.
        var giftStillValid = state.gift === 'none' ||
          (state.gift && CFG.boxes[value].gifts.indexOf(state.gift) !== -1);
        var patch = { box: value };
        if (!giftStillValid) {
          patch.gift = null;
          state.done[4] = false;
        }
        answer(3, patch);
        return;
      }
      if (group === 'gift') { answer(4, { gift: value }); return; }
      return;
    }

    if (t.hasAttribute('data-gb-split')) {
      var op = t.getAttribute('data-gb-split');
      // Decaf steppers move Single Origin the other way — the pair always sums to qty.
      if (op === 'so-inc' || op === 'dc-dec') setSplit(d.soQ + 1);
      else setSplit(d.soQ - 1);
      return;
    }

    if (t.hasAttribute('data-gb-dropzone')) {
      var input = el('[data-gb-file]');
      if (input) input.click();
      return;
    }

    if (t.hasAttribute('data-gb-removelogo')) {
      state.logo = null;
      render();
      return;
    }

    if (t.hasAttribute('data-gb-addtocart')) {
      submitToCart(d, t);
      return;
    }

    if (t.hasAttribute('data-gb-advance')) {
      if (d.allPacked) {
        if (CFG.checkoutMode === 'cart') {
          submitToCart(d, el('[data-gb-addtocart]') || t);
          return;
        }
        if (CFG.checkoutMode === 'laurie') {
          submitToLaurie(d, el('[data-gb-submit]') || t);
          return;
        }
        var form = el('#gift-builder-form');
        if (form) {
          var firstEmpty = form.querySelector('input[required]:invalid');
          (firstEmpty || form).scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
          if (firstEmpty) firstEmpty.focus();
          else form.requestSubmit();
        }
        return;
      }
      advance(d);
    }
  });

  function submitToCart(d, button) {
    if (!d.allPacked || d.underMoq) {
      openStep(d.underMoq ? 1 : firstUndone());
      return;
    }

    var err = el('[data-gb-carterror]');
    if (err) err.hidden = true;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    addToCart(d)
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (e) {
        if (err) {
          err.hidden = false;
          err.textContent = e.message || 'Could not add to cart.';
        }
        if (button) { button.disabled = false; button.textContent = 'Add to cart'; }
      });
  }

  function advance(d) {
    var n = state.open;
    if (n === 1) { if (!d.underMoq) answer(1, {}); return; }
    if (n === 2) { answer(2, {}); return; }
    if (n === 3) { answer(3, {}); return; }
    if (n === 4) { if (state.gift) answer(4, {}); return; }
    if (n === 5) { answer(5, {}); return; }
    openStep(firstUndone());
  }

  root.addEventListener('input', function (ev) {
    if (!ev.target.matches('[data-gb-qtyinput]')) return;
    var v = parseInt(ev.target.value, 10);
    state.qty = isNaN(v) ? 0 : Math.max(0, v);
    // Safe to go through the normal path: a quantity change doesn't alter the
    // structure key, so this patches in place and the field keeps focus.
    render();
  });

  root.addEventListener('change', function (ev) {
    if (!ev.target.matches('[data-gb-file]')) return;
    handleFile(ev.target.files && ev.target.files[0]);
  });

  // Drop the entry-animation class once it has played, so the DOM doesn't
  // claim a card is still animating.
  root.addEventListener('animationend', function (ev) {
    if (ev.animationName === 'gb-in' && ev.target.classList.contains('gb-card--enter')) {
      ev.target.classList.remove('gb-card--enter');
    }
  });

  // Drag and drop onto the upload zone
  root.addEventListener('dragover', function (ev) {
    var zone = ev.target.closest('[data-gb-dropzone]');
    if (!zone) return;
    ev.preventDefault();
    if (!state.drag) { state.drag = true; render(); }
  });

  root.addEventListener('dragleave', function (ev) {
    if (!ev.target.closest('[data-gb-dropzone]')) return;
    if (state.drag) { state.drag = false; render(); }
  });

  root.addEventListener('drop', function (ev) {
    var zone = ev.target.closest('[data-gb-dropzone]');
    if (!zone) return;
    ev.preventDefault();
    handleFile(ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files[0]);
  });

  // Fill the hidden fields at submit time and stash a snapshot for the
  // confirmation screen, which renders after Shopify's POST/redirect.
  var quoteForm = el('#gift-builder-form');
  if (quoteForm) {
    quoteForm.addEventListener('submit', function (ev) {
      var d = derive();

      // Guard the native submit path too — Enter in a text field bypasses the
      // sticky bar's button entirely.
      if (!d.allPacked || d.underMoq) {
        ev.preventDefault();
        openStep(d.underMoq ? 1 : firstUndone());
        return;
      }

      // Laurie mode reuses this form for contact details but posts JSON to
      // Laurie instead of letting Shopify's contact form take the submit.
      if (CFG.checkoutMode === 'laurie') {
        ev.preventDefault();
        submitToLaurie(d, el('[data-gb-submit]'));
        return;
      }

      var snap = buildSnapshot(d);

      var values = {
        qty: String(d.qty),
        bottle: snap.bottle,
        box: snap.box,
        gift: snap.gift,
        sleeve: snap.sleeve,
        logo: state.logo ? state.logo.name + ' (customer to email artwork)' : 'GRADA sleeve, no logo',
        tier: d.pct > 0 ? d.pct + '% off' : 'No volume discount',
        perbox: snap.perBox,
        total: snap.total,
        json: JSON.stringify({
          qty: d.qty, mix: state.mix, soQty: d.soQ, decafQty: d.dcQ,
          box: state.box, gift: state.gift,
          logo: state.logo ? state.logo.name : null,
          tierPct: d.pct, totalEx: Math.round(d.totalEx * 100) / 100,
          source: 'gift box builder'
        })
      };

      Object.keys(values).forEach(function (k) {
        var input = el('[data-gb-hidden="' + k + '"]');
        if (input) input.value = values[k];
      });

      writeSnapshot(snap);
    });
  }

  /* ============================================================
     HERO FLIPBOOK — rapid flicks that decelerate into a calm loop
     ============================================================ */

  function startFlipbook() {
    if (reducedMotion()) return;
    var frames = root.querySelectorAll('[data-gb-flipbook] .gb-intro__frameimg');
    if (frames.length < 2) return;

    var cadence = [110, 110, 110, 110, 110, 130, 150, 180, 220, 270, 330, 410, 510, 640, 800, 1000, 1300, 1700];
    var i = 0;
    var current = 0;
    var timer;

    function tick() {
      if (state.view === 'intro') {
        frames[current].classList.remove('is-on');
        current = (current + 1) % frames.length;
        frames[current].classList.add('is-on');
      }
      var delay = i < cadence.length ? cadence[i++] : 2400;
      timer = setTimeout(tick, delay);
    }

    timer = setTimeout(tick, 500);
    window.addEventListener('pagehide', function () { clearTimeout(timer); });
  }

  /* ============================================================
     ROUTING + BOOT
     ============================================================ */

  window.addEventListener('popstate', function () {
    var h = (location.hash || '').replace('#', '');
    state.view = h === 'build' ? 'build' : h === 'done' ? 'done' : 'intro';
    render();
    window.scrollTo({ top: 0, behavior: 'auto' });
  });

  // Shopify redirects to ?contact_posted=true after a successful contact form
  // POST. That redirect is the only signal available here — the Liquid `form`
  // object is scoped to the {% form %} block and cannot be read on page load.
  var bootHash = (location.hash || '').replace('#', '');
  if (/[?&]contact_posted=true/.test(location.search)) {
    state.view = 'done';
  } else if (bootHash === 'done' && readSnapshot()) {
    // A Laurie order has already been placed. Reloading must not strand the
    // customer away from their invoice link — it and the order number live
    // only in the snapshot.
    state.view = 'done';
  } else {
    if (bootHash === 'build') state.view = 'build';
    clearSnapshot();
  }

  syncHeaderOffset();
  window.addEventListener('resize', syncHeaderOffset);
  // The header renders before the builder's fonts settle, and it can reflow
  // once webfonts land — re-measure after that rather than trusting one read.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeaderOffset);

  render();
  startFlipbook();
})();
